module.exports = __webpack_public_path__ + "img/underline.e06b5473.svg";